import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import ArticleCard from '../../components/cards/ArticleCard';
import VideoCard from '../../components/cards/VideoCard';
import Link from '../../components/Link';
import { getColumnLg, getColumnMd, getLayout, getRowLg } from './helper/grid';

const ComposableMixedContent = (props) => {
  const { index, slug, type, total, __typename, id } = props;
  const layout = getLayout(index, total);

  const getHrefStructure =
    __typename === 'Media' ? `/media/${id}` : `/artikelen/${slug}`;

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd={getColumnMd(layout.tablet, total)}
      columnEndLg={getColumnLg(layout.desktop, index, total)}
      rowEndLg={getRowLg(index, total)}
      key={slug}
    >
      <Link
        href={getHrefStructure}
        category="Homepage"
        label={`${type}-${index}`}
        action="click"
      >
        {__typename === 'Media' && <VideoCard layout={layout} {...props} />}
        {__typename === 'Article' && <ArticleCard layout={layout} {...props} />}
      </Link>
    </GridItem>
  );
};

ComposableMixedContent.propTypes = {
  __typename: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export default ComposableMixedContent;
